import { customerFinding } from '@aot-aiops/shared';

/** Re-resolve legacy cached summaries; diagnostics keep the original record. */
export function FindingSummary({
  finding,
  entityName,
}: {
  finding: Record<string, unknown>;
  entityName?: string;
}) {
  return <strong>{customerFinding(finding, entityName).summary}</strong>;
}
